import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium transition-all duration-300 ease-out rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-burgundy-500 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-burgundy-900 text-white hover:bg-burgundy-800 hover:scale-[1.02] shadow-lg shadow-burgundy-900/20',
    secondary: 'bg-gold-500 text-white hover:bg-gold-600 hover:scale-[1.02] shadow-lg shadow-gold-500/20',
    outline: 'border-2 border-burgundy-900 text-burgundy-900 hover:bg-burgundy-50 hover:scale-[1.02]'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-1">
      {children}
    </button>;
}